import React, { Component } from 'react'
import NetworkIndicator from './NetworkIndicator'

interface Props {
  logo?: string
  username: string
}

export default class User extends Component<Props> {
  get logo () {
    const { logo } = this.props
    return logo &&
      <img
        className="w-full h-full object-cover rounded-full"
        src={logo} />
  }

  render () {
    return (
      <div className="flex items-center gap-3">
        <div className="w-9 h-9">
          {this.logo}
        </div>
        <div className="text-white">
          <div className="font-medium leading-5">
            {this.props.username}
          </div>
          <NetworkIndicator />
        </div>
      </div>
    )
  }
}
